import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';
import { recordPreviewSectionStyles } from '#/common/components/RecordPreview/RecordPreviewSection';

const Styles = styled.div`
  ${recordPreviewSectionStyles}

  .nuvo-record-preview-actions {
    .dx-box.dx-collection {
      display: flex;
      flex-direction: row !important;
      gap: 12px;
      padding-bottom: 20px;

      .dx-item.dx-box-item {
        flex-grow: initial !important;

        .dx-field-item {
          padding: 0;
        }
      }
    }
    &-mobile {
      flex-direction: row-reverse;
    }
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 32px !important;
    padding-right: 24px !important;
    margin: 0 !important;
    gap: 12px;

    .dx-button {
      height: 40px !important;
      line-height: 40px !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }
`;

export default Styles;
